import BasePlugin from "../base/BasePlugin";
import { getTopLevelRecords } from "data/selectors/superRecords";
import TableStore from "data/TableStore";
import SuperRecordStore from "data/SuperRecordStore";
import NavigatorStore from "data/NavigatorStore";
import LoadObject from "data/LoadObject";

export default class CrossRecordPlugin extends BasePlugin {
    initialize(options = {}) {
        super.initialize(options);

        this.set("name", "Cross Record");
        this.set("id", "cross-record");
        this.set("fluxContext", "CTX_MappingPlugin_CrossRecord");
        this.set("fields", []);
    }

    getButtonListingPrefix() {
        return "Map From ";
    }

    getPagination() {
        return {
            page: 1,
            pageCount: 1,
            pageSize: 25,
            totalResultCount: 0,
        };
    }

    getQueryLO(query, initiate) {
        const magic = NavigatorStore.getMagicState(this.fluxContext);
        const srInfo = SuperRecordStore.getRecord(magic.key, magic.id);
        const tlrs = getTopLevelRecords(TableStore, srInfo);
        return LoadObject.withValue(
            tlrs.filter(it => !it.equals(this.activeRecord)));
    }


    searchFromActiveRecord() {
        return this._searchInternal({}, true);
    }
}



// WEBPACK FOOTER //
// ./app/lib/mapping/sources/cross-record/CrossRecordPlugin.js